import {
  useAppContext 
} from "@/context/app"
export const useNavigationTrigger = () => {
  const [appState, {
    toggleDrawer, closeDrawer 
  }] = useAppContext()

  const handleToggleNavigation = () => {
    toggleDrawer("nav")
  }

  return {
    handleToggleNavigation,
    appState,
    closeDrawer,
  }
}
